import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import BenefitStatusInfoCard from "./BenefitStatusInfoCard";
import { VoucherCard } from "./VoucherCard";

const TripCriteriaMetCard = ({ item }) => {
  const isMobile = useMediaQuery("(max-width: 1200px)");
  const showTripCriteriaMetCard = !!(
    item?.header_info ||
    item?.criteria?.length > 0 ||
    item?.benefit_status_info
  );

  return (
    <Box
      sx={
        showTripCriteriaMetCard
          ? {
              p: 2,
              borderRadius: 2,
              backgroundColor: "#fff",
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }
          : {
              borderRadius: 2,
            }
      }>
      {item?.trip_voucher_details && (
        <VoucherCard voucherData={item.trip_voucher_details} />
      )}
      {showTripCriteriaMetCard && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {item?.header_info && (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between">
                <Typography variant="h2">
                  {item?.header_info?.display_label}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 0.5,
                  }}>
                  <Typography variant="labelD">Period:</Typography>
                  <Typography variant="body1">
                    {item?.header_info?.value}
                  </Typography>
                </Box>
              </Box>
            )}
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={1} alignItems={"center"}>
              {item?.criteria?.map((info, index) => (
                <Grid
                  key={`${info?.display_label || "criteria"}-${index}`}
                  item
                  xs={4}
                  sm={4}>
                  <Box
                    sx={{
                      borderRight:
                        index !== item?.criteria?.length - 1
                          ? "2px solid #A3A3A380"
                          : "none",
                    }}>
                    <Typography
                      variant={isMobile ? "labelM" : "labelD"}
                      sx={{ color: "#666666", mb: 0.2 }}>
                      {info?.display_label}
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="600"
                      sx={{
                        color: !info?.is_minimum_achieved
                          ? "#CC0000"
                          : "#333333",
                      }}>
                      {info.value}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
          {item?.benefit_status_info && (
            <Grid item xs={12}>
              <BenefitStatusInfoCard data={item?.benefit_status_info} />
            </Grid>
          )}
        </Grid>
      )}
    </Box>
  );
};

export default TripCriteriaMetCard;
